<div class="flexBox start">
	<div class="labelWrapper">
		<label class="primary">{{ primaryLabel() | translate }}</label>
		<label class="secondary">{{ secondaryLabel() | translate }}</label>
	</div>
</div>
<div class="flexBox end">
	<sim-button
		(onClick)="add.emit()"
		[icon]="{fontIcon: 'fa-plus', fontSet: 'far'}"
		[label]="buttonLabel()"
		[variant]="inputButtonVariant() === 'primary' ? 'flat' : 'stroked'"
		[disabled]="disabled()"
		size="small"
	/>
</div>
